import { Garment } from './garment.model';
import { IPerson } from '../../../+common/contracts/person.model.contract';
import { Product } from './product.model';
import { ProductCategory } from './product-category.model';

export class GarmentFull {
  garment: Garment;
  person: IPerson;
  product: Product;
  productCategory: ProductCategory;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/garment-full.model.ts